import { createComponentWrapperWithRef, ListItemText, styled } from '@msdk/ui'

const StyledSidebarListItemText = styled(ListItemText)`
  color: inherit;
  margin-top: 0;
  margin-bottom: 0;
  flex: unset;
`

const NovaStyledSidebarListItemText = styled(StyledSidebarListItemText)`
  padding: 0;
`

export const SidebarListItemText = createComponentWrapperWithRef(
  {
    mui: StyledSidebarListItemText,
    nova: NovaStyledSidebarListItemText,
  },
  'SidebarListItemText',
)
